<template>
    <b-form-select
        v-model="selectedValue"
        :class="reactiveClass"
        size="sm"
        :options="typeOptions"
        @change="save"
    />
</template>

<script>
import TableFormHandler from '../../../common/mixins/TableFormHandler'

export default {
    name: 'TypeForm',

    mixins: [TableFormHandler],

    props: {
        entry: {},
    },

    data() {
        return {
            form: {},
            typeOptions: [],
            selectedValue: {
                id: 0,
                type: '',
            },
        }
    },

    async created() {
        this.align = 'left'
        await this.getAffectationOptions()
        this.setSelectedValue()
    },

    methods: {
        async getAffectationOptions() {
            const url =
                this.entry.client !== null
                    ? `/time-sheet-options/billable/${this.entry.client.id}`
                    : '/time-sheet-options/non-billable-selectable'
            try {
                const response = await this.$axios.get(url)
                this.typeOptions = response.data.data
            } catch (error) {
                console.log(error)
            }
        },

        setSelectedValue() {
            this.selectedValue.id =
                this.entry.client_event_id === null
                    ? this.entry.time_sheet_option_id
                    : this.entry.client_event_id

            this.selectedValue.type =
                this.entry.client_event_id === null ? 'timeSheetOption' : 'todo'
        },

        async save() {
            this.form.activity_date = this.entry.activity_date
            this.form.type = this.selectedValue.type
            this.form.id = this.selectedValue.id
            try {
                await this.$axios.put(
                    `/time-sheets/${this.entry.id}/type`,
                    this.form
                )
                this.handleSelectSuccess()
                // this.$root.$refs.timeSheetsInput.getData()
            } catch (error) {
                console.log(error)
                this.handleError()
                if (error.response) {
                    if (error.response.status === 403) {
                        this.$store.commit(
                            'timeSheetsVM/SET_ERROR',
                            error.response.data.meta.message
                        )
                    }
                }
            }
        },
    },
}
</script>

<style scoped></style>
